import { render, staticRenderFns } from "./UserPopUp.vue?vue&type=template&id=3f4a5aa6&scoped=true&"
import script from "./UserPopUp.vue?vue&type=script&lang=js&"
export * from "./UserPopUp.vue?vue&type=script&lang=js&"
import style0 from "./UserPopUp.vue?vue&type=style&index=0&id=3f4a5aa6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4a5aa6",
  null
  
)

export default component.exports